import React from 'react';
import './Carousel.css';

const base = `${process.env.PUBLIC_URL}/images/car_image/`;
const images = [
  'car-1.png',
  'car-2.png',
  'car-3.png',
  'car-4.png',
  'car-5.png',
  'car-6.png',
  'car-7.png',
  'mahindra2.png'
].map(name => base + name);

export default function Carousel(){
  const list = [...images, ...images];
  return (
    <section className="marquee-section" aria-roledescription="carousel">
      <div className="marquee-heading container"><h3 className="marquee-title fw-bold text-center">Our Clients</h3></div>
      <div className="marquee-viewport">
        <div className="marquee-track">
          {list.map((src, idx)=> (
            <div key={idx} className={`marquee-item ${src.includes('lo.jpg') ? 'marquee-item-large' : ''}`}>
              <img src={src} alt="carousel" onError={(e)=>{ e.currentTarget.style.opacity = 0.3; }} />
            </div>
          ))}
        </div>
         <div className="marquee-track">
          {list.map((src, idx)=> (
            <div key={idx} className={`marquee-item ${src.includes('lo.jpg') ? 'marquee-item-large' : ''}`}>
              <img src={src} alt="carousel" onError={(e)=>{ e.currentTarget.style.opacity = 0.3; }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
